var React = require('react');

function GrayCircle (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"60.486","cy":"59.5631","r":"54.5","transform":"rotate(9.65378 60.486 59.5631)","stroke":"#DFE0E3","strokeWidth":"10"}));
}

GrayCircle.defaultProps = {"width":"120","height":"120","viewBox":"0 0 120 120","fill":"none"};

module.exports = GrayCircle;

GrayCircle.default = GrayCircle;
